import Checkbox from '@jetbrains/ring-ui/components/checkbox/checkbox'
import Select from '@jetbrains/ring-ui/components/select/select'
import React, {memo} from 'react'

import styles from '../JobDependencies.css'

import {jobDependencySelectItems} from './JobDependency.consts'
import useJobDependency from './JobDependency.hooks'
import type {JobDependencyProps} from './JobDependency.types'

function JobDependency({depId, jobId, enabled = false, onEnabled}: JobDependencyProps) {
  const {
    dependencyName,
    hasDependencyFilesPublication,
    selectedJobDependencyItem,
    isJobDependencyDisabled,
    handlerJobDependencySelect,
    handlerJobDependencyMouseHover,
  } = useJobDependency(jobId, depId)
  const isShowJobDependencySelect = enabled && hasDependencyFilesPublication

  return (
    <div
      onMouseEnter={handlerJobDependencyMouseHover(depId)}
      onMouseLeave={handlerJobDependencyMouseHover(null)}
      key={depId}
      className={styles.jobDependency}
    >
      <Checkbox
        label={dependencyName}
        title={dependencyName}
        checked={enabled}
        onChange={onEnabled}
        containerClassName={styles.jobDependencyCheckboxLabel}
        disabled={isJobDependencyDisabled}
      />
      {isShowJobDependencySelect && (
        <Select
          type={Select.Type.INLINE}
          className={styles.editFilesSelect}
          buttonClassName={styles.editFilesSelectButton}
          selected={selectedJobDependencyItem}
          data={jobDependencySelectItems}
          onSelect={handlerJobDependencySelect}
        />
      )}
    </div>
  )
}

export default memo(JobDependency)
